export default (() => {
  // add all images as assets
  if (typeof require !== 'undefined') {
    require.context('bender-url!../../images', true);
  }
});